import React from "react";
import {makeStyles, createStyles, Theme} from "@material-ui/core/styles";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import AddBoxIcon from "@material-ui/icons/AddBox";
import {
  alertsConfirmAction,
  userModalOpenAction,
} from "../features/sliceReducer/interactionReducer";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../features/store";
import {deleteMemberAction} from "../features/sliceReducer/projectReducer";

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    caption: {
      padding: "24px 0 0 24px",
      fontWeight: "bold",
      fontSize: "18px",
    },
    tableContainer: {
      position: "relative",
      display: "flex",
      padding: "0px 24px 40px",
    },
    table: {
      "& .MuiTableCell-root": {
        padding: "12px",
      },
    },
  })
);

const AddParticipant = () => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const {currentProject} = useSelector((state: RootState) => state.project);

  return (
    <React.Fragment>
      <Box>
        <Typography variant="subtitle1">
          <PersonAddIcon
            style={{marginRight: "8px", verticalAlign: "middle"}}
          />
          PSM 프로젝트 참여자
        </Typography>
        <Box className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>참여자 아이디</TableCell>
                <TableCell>참여자 이름</TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxIcon />}
                    onClick={() => dispatch(userModalOpenAction())}
                  >
                    참여자
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentProject?.participantsUsers?.map((user, index) => (
                <TableRow key={user.uid}>
                  <TableCell>{user.uid}</TableCell>
                  <TableCell>{user.name}</TableCell>
                  <TableCell align="right">
                    <Button
                      onClick={() => {
                        dispatch(
                          alertsConfirmAction({
                            alertContent: "해당 참여자를 삭제하시겠습니까?",
                            alertAction: deleteMemberAction(user.uid),
                          })
                        );
                      }}
                    >
                      <IndeterminateCheckBoxIcon
                        style={{
                          color: "#f44336",
                          fontSize: "26px",
                        }}
                      />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default AddParticipant;
